module.exports = __webpack_public_path__ + "static/img/ship-cargo_256.8e0fb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-cargo_256.png
// module id = d5hL
// module chunks = 0